import { useCallback } from 'react'
import { useAlertDialogContext } from 'src/AlertDialog'
import { useModalState } from 'src/Modal/ModalStateContext'
import { ModalFormId } from 'src/components/ModalForms'

export type AlertDialogModalProps = {
  title: string
  body: string
}

export type ShowAlertDialog = (props: AlertDialogModalProps) => void

export const useAlertDialogModal = (): ShowAlertDialog => {
  const { setAlertDialogState } = useAlertDialogContext()
  const { openModal } = useModalState()
  return useCallback(
    (props: AlertDialogModalProps) => {
      setAlertDialogState({ ...props })
      openModal(ModalFormId.ALERT_DIALOG)
    },
    [setAlertDialogState, openModal],
  )
}
